import { TempFileServiceError } from "./TempFileServiceError";

export class FailedToGetTempFileUrls extends TempFileServiceError {}
